import { Field } from '@/components/ui/Field';
import { PasswordField } from '@/components/ui/PasswordField';

import { State } from '../State';

export function PasswordFieldExamples() {
  return (
    <State
      title="With the show control"
      note="The eye is a real button, so it works by keyboard and says its state."
    >
      <Field label="Password">
        <PasswordField defaultValue="correct horse battery" />
      </Field>
    </State>
  );
}
